/* Copyright 2020 The MathWorks, Inc. */

/**
 * This module should return an array of "types" of components that are now using the new consolidated
 * StatusBar Widgets.
 */

define([
        "MW/statusbar/TypeConstants"
], function (TypeConstants) {
    
    return [
        TypeConstants.STATUS_LABEL,
        TypeConstants.STATUS_PROGRESS_BAR,
        TypeConstants.STATUS_PUSH_BUTTON,
        TypeConstants.STATUS_TEXT_FIELD,
        TypeConstants.STATUS_TOGGLE_BUTTON
    ];
});